// 同意文言編集 本文入力欄
import React from 'react';
import ReactQuill from 'react-quill';
import { Quill } from 'react-quill';

interface Props {
  class_name: string;
  text?: string;
  handleChange: any;
}

const Wysiwyg: React.FC<Props> = ({ class_name, text, handleChange }) => {
  // 使用するフォント
  const Font = Quill.import('formats/font');
  Font.whitelist = ['', '明朝'];
  Quill.register(Font, true);

  const modules = {
    toolbar: [
      ['bold', 'underline'], // 太字、下線
      [{ list: 'ordered' }, { list: 'bullet' }], // 番号リスト、黒点リスト
      [{ align: [false, 'center', 'right'] }], // 左寄せ、中央寄せ、右寄せ
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // 文字サイズ h1 ~ h6
      [{ font: Font.whitelist }], // フォント選択
    ],
  };

  const formats = ['header', 'bold', 'underline', 'list', 'bullet', 'font', 'align'];

  return (
    <ReactQuill
      className={class_name}
      theme="snow"
      value={text}
      onChange={handleChange}
      modules={modules}
      formats={formats}
    />
  );
};

export default Wysiwyg;
